module.exports = __webpack_public_path__ + "static/img/CH.637c971.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/countries/CH.svg
// module id = MyPs
// module chunks = 1